
import React from 'react';

const services = [
  {
    title: 'Ai & Tech Integrations',
    description: 'Implementing high-level Ai and technical architecture to automate complex workflows and drive innovation. Building rapid apps which scale.',
    icon: '01'
  },
  {
    title: 'Management & Consulting',
    description: 'Operational strategies and high-level management practices for streamlining business practices with expertise in entertainment and technology.',
    icon: '02'
  },
  {
    title: 'STRATEGIC DIGITAL MARKETING',
    description: 'We build digital marketing ecosystems that elevate brand narrative, accelerate customer acquisition, and create defensible competitive advantages across multiple verticals.',
    icon: '03'
  }
];

const Services: React.FC = () => {
  return (
    <section id="services" className="py-24 md:py-40 bg-[#0f0f0f] border-y border-white/5">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-start mb-24 gap-12">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-6xl font-syne font-bold mb-8 tracking-tighter uppercase">OUR SPECIALIZATIONS.</h2>
            <div className="w-24 h-1 bg-white mb-8"></div>
          </div>
          <div className="max-w-xl">
            <p className="text-neutral-400 text-lg leading-relaxed">
              We’re a technology-driven marketing agency that builds the operational engines and creative systems brands need to scale. We transform ideas into infrastructure—so your vision can grow without friction or limits.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="group p-8 md:p-10 border border-white/5 bg-[#0a0a0a] hover:border-white/20 transition-all duration-500 relative overflow-hidden flex flex-col justify-between min-h-[400px]">
              <div className="absolute top-0 right-0 p-6 text-6xl font-syne font-black text-white/5 group-hover:text-white/10 transition-colors">
                {service.icon}
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-syne font-bold mb-6 pt-12 uppercase tracking-tight leading-tight">{service.title}</h3>
                <p className="text-neutral-400 leading-relaxed mb-8">
                  {service.description}
                </p>
              </div>
              <div className="flex items-center space-x-2 text-xs font-bold tracking-widest uppercase group-hover:translate-x-2 transition-transform">
                <span>Inquire</span>
                <span className="text-lg">→</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
